
(function uniqueValidationModuleDefinition() {

    'use strict';

    angular.module('UniqueValidation', [])
        .directive('checkUnique', ['$q',
            function($q) {
                return {
                    require: 'ngModel',
                    link: function(scope, ele, attrs, c) {
                        scope.$watch(attrs.ngModel, function(value) {
                            if (value != null) {
                                $q.when(scope.$eval(attrs.checkUnique, { '$value': value }))
                                    .then(function(result) {
                                        c.$setValidity('unique', ((result && true) || false));
                                    });
                            }
                        });
                    }
                };
            }
        ]);
})();